export default __webpack_public_path__ + "static/media/insight.3a6803d8.svg";